import { Redirect } from "react-router-dom";
import type { Location } from "history";

import routesObject from "../../routesObject";

interface LoginRedirectProps {
  location: Location;
}

export default function LoginRedirect({ location }: LoginRedirectProps) {
  // Type assertion to work around React Router v5 + React 17 type conflicts
  const RedirectComponent = Redirect as any;
  return (
    <RedirectComponent to={`${routesObject.login.url}${location.search}`} />
  );
}
